import * as urlUtils from 'utils/Url';


export function getPathBackInStockOverview(qs={}) {
  return urlUtils.appendQueryString(`/back-in-stock-overview`, qs);
}

export function getPathBackInStockAnalytics(qs={}) {
  return urlUtils.appendQueryString(`/back-in-stock-analytics`, qs);
}

export function getPathBackInStockConnections(qs={}) {
  return urlUtils.appendQueryString(`/back-in-stock-connections`, qs);
}

export function getPathAddBackInStock() {
  return `/back-in-stock/add`;
}

export function getPathEditBackInStock() {
  return `/back-in-stock/edit`;
}

export function getPathBackInStockInventoryItems(qs={}) {
  return urlUtils.appendQueryString(`/back-in-stock-inventory-items`, qs);
}

export function getPathBackInStockSubscribers(qs={}) {
  return urlUtils.appendQueryString(`/back-in-stock-subscribers`, qs);
}

export function getPathBackInStockSyncLogs(qs={}) {
  return urlUtils.appendQueryString(`/back-in-stock-sync-logs`, qs);
}

export function getPathBackInStockNotifications(qs={}) {
  return urlUtils.appendQueryString(`/back-in-stock-notifications`, qs);
}

export function getPathBackInStockEmailRecipients(qs={}) {
  return urlUtils.appendQueryString(`/back-in-stock-email-recipients`, qs);
}

export function getPathBackInStockEmailAnalytics(qs={}) {
  return urlUtils.appendQueryString(`/back-in-stock-email-analytics`, qs);
}

export function getPathBackInStockEmailConversions(qs={}) {
  return urlUtils.appendQueryString(`/back-in-stock-email-conversions`, qs);
}
